import api, { setAccessToken } from "../api";
import { errorManager } from "../util";


export const RPT_OK='RPT_OK';
export const RPT_KO ='RPT_KO';

//Actions
export const RptOk=(value)=>{
    return {
        type: RPT_OK,
        payload: value
    }
}

export const RptKo=(value)=>{
    return {
        type: RPT_KO,
        payload: value
    }
}

export const getCases=(row, callBack)=>{
    document.body.className='loading';
    return (dispach)=>{
        
        api.post("/Casos/GetRptCasos",row)
        .then(response=>{
            //console.log(response.data);
            dispach(RptOk(response.data));
            if (callBack!==undefined){
                callBack(response.data,null);
            }
            document.body.className='';
        }).catch(error=>{
            //console.log(error);
            dispach(RptKo(null));
            if (callBack!==undefined){
                callBack(null,error);
            }
            document.body.className='';
            errorManager(error);
        });
    }
}


export const DistCaso=(row, callBack)=>{
    document.body.className='loading';
    return (dispach)=>{
        api.post("/Casos/DistCaso",row)
        .then(response=>{
            //console.log(response.data);
            if (callBack!==undefined){
                callBack(response.data,null);
            }
            document.body.className='';
        }).catch(error=>{
            //console.log(error);
            if (callBack!==undefined){
                callBack(null,error);
            }
            document.body.className='';
            errorManager(error);
        });
    }
}



export const ComentarCaso=(row, callBack)=>{
    document.body.className='loading';
    return (dispach)=>{
        api.post("/Casos/Comments",row)
        .then(response=>{
           //console.log(response.data);
            if (callBack!==undefined){
                callBack(response.data,null);
            }
            document.body.className='';
        }).catch(error=>{
            //console.log(error);
            if (callBack!==undefined){
                callBack(null,error);
            }
            document.body.className='';
            errorManager(error);
        });
    }
}

export default getCases;